import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";

// Pages
import HomePage from "./pages/HomePage";
import ShopPage from "./pages/ShopPage";
import ActivatePage from "./pages/ActivatePage";
import PetProfilePage from "./pages/PetProfilePage";
import DashboardPage from "./pages/DashboardPage";
import HowItWorksPage from "./pages/HowItWorksPage";
import FAQPage from "./pages/FAQPage";
import ContactPage from "./pages/ContactPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import AuthCallback from "./pages/AuthCallback";
import ReportSightingPage from "./pages/ReportSightingPage";
import TagPage from "./pages/TagPage";
import ScanPage from "./pages/ScanPage";
import ShortCodeRedirect from "./pages/ShortCodeRedirect";

function AppRouter() {
  const location = useLocation();

  // Check URL fragment for session_id from Google OAuth
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/shop" element={<ShopPage />} />
      <Route path="/activate" element={<ActivatePage />} />
      <Route path="/activate/:tagId" element={<ActivatePage />} />
      <Route path="/tag/:tagId" element={<TagPage />} />
      <Route path="/scan" element={<ScanPage />} />
      <Route path="/pet/:petId" element={<PetProfilePage />} />
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/how-it-works" element={<HowItWorksPage />} />
      <Route path="/faq" element={<FAQPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/report-sighting/:petId" element={<ReportSightingPage />} />
      {/* Short code redirect for QR codes - must be last */}
      <Route path="/:code" element={<ShortCodeRedirect />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
